const now = new Date()
export const oneMonthFromNow = new Date(now.setMonth(now.getMonth() + 1))
